<nav aria-label="File folders">
  <h2>Folders</h2>
  <ng-container *ngTemplateOutlet="branches; context: {$implicit: roots}"></ng-container>
  <p *ngIf="pathError" class="br-text-muted" role="alert">Unable to show the folder path.
    <button type="button" class="br-btn br-btn--ghost br-btn--sm" (click)="reveal()">Retry</button>
  </p>
</nav>
<ng-template #branches let-nodes>
  <ul>
    <li *ngFor="let node of nodes" [attr.aria-busy]="node.loading">
      <div class="folder-row">
        <button type="button" class="br-btn br-btn--ghost br-icon-btn br-interactive folder-toggle"
                [attr.aria-label]="(node.expanded ? 'Collapse ' : 'Expand ') + node.name" [attr.aria-expanded]="node.expanded" (click)="toggle(node)">
          <br-icon class="br-text-muted">{{ node.expanded ? 'expand_more' : 'chevron_right' }}</br-icon>
        </button>
        <button type="button" class="folder-link br-btn br-btn--ghost br-interactive" [attr.aria-current]="selected(node) ? 'page' : null" [title]="node.name" (click)="choose(node)"
                [fileDropTarget]="{ area: node.area, folder: node.id }" [canDropFile]="canDropFile" (fileDropped)="fileDropped.emit($event)">
          <br-icon class="folder-icon" [svgIcon]="node.expanded ? 'br:folder-open' : 'br:folder'"></br-icon><span>{{ node.name }}</span>
        </button>
      </div>
      <ng-container *ngIf="node.expanded">
        <ng-container *ngTemplateOutlet="branches; context: {$implicit: node.children}"></ng-container>
        <p *ngIf="node.error" class="folder-status" role="alert">Couldn't load folders.
          <button type="button" class="br-btn br-btn--ghost br-btn--sm" (click)="load(node)">Retry</button>
        </p>
        <p *ngIf="node.page && !node.loading && !node.error && !node.children.length" class="folder-status br-text-muted">No subfolders</p>
        <button *ngIf="node.more && !node.error" type="button" class="br-btn br-btn--ghost br-btn--sm" [disabled]="node.loading" (click)="load(node)">More folders</button>
      </ng-container>
    </li>
  </ul>
</ng-template>
